import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_SLOTS_BY_LOCATIONS
    FETCH_SLOTS_BY_LOCATIONS_SUCCESS
    FETCH_SLOTS_BY_LOCATIONS_FAILURE

    SET_INSPECTION_TYPE
    SET_SELECTED_BRANCH
    SET_INSPECTION_DATE
    SET_INSPECTION_TIME

    SUBMIT_APPOINTMENT
    SUBMIT_APPOINTMENT_SUCCESS
    SUBMIT_APPOINTMENT_FAILURE

    RESET_SELECTIONS

    SEND_OTP_SUCCESS
    
    SET_EDIT_MODE

    UPDATE_API_STATUS

    SET_WHATSAPP_NOTIFICATION_STATUS

    RESTORE_APPOINTMENT_FORM

    SET_PREFILLED_BRANCH

    SET_PREFIIED_INSPECTION_TYPE

    SET_SELL_BIKE_CONSENT

    RESET_LOCATION_DATA

    SET_ADDRESS
    SET_LANDMARK
    SET_APPOINTMENT_SCREEN
    SET_APPOINTMENT_ID

    SET_PREVIOUS_SELECTED_ZONE

    APPLY_SELECTIONS_AND_DATA
    SET_ADDRESS_TYPE
    SET_IS_HI_AVAILABLE
    SET_INSPECTION_LOCATION
    SET_CURRENT_LOCATION_NAME
    SET_IS_LOCATION_SEARCH_ENABLED
    SET_LOCATION
    SET_LOCATION_COORDS
    TOGGLE_LOCATION_DRAWER
`,
    {
        prefix: "bookappointmentform/"
    }
);
